import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
              What Is a Sugargoo Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-3">
              A <strong>Sugargoo Spreadsheet</strong> is a carefully organized collection of product links, seller
              reviews, quality check photos, and pricing data compiled by experienced Sugargoo shoppers.
              Instead of spending hours manually searching through endless listings, these spreadsheets
              give you instant access to verified, community-tested finds across dozens of categories.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-3">
              Think of it as your personal shopping assistant — every entry in a Sugargoo Spreadsheet has been vetted
              by real buyers who have already done the hard work. They&apos;ve checked the quality, compared prices,
              verified the sellers, and documented their findings so you can shop with confidence.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              Whether you&apos;re hunting for the latest sneaker releases, looking for budget streetwear pieces,
              or trying to find hidden gem accessories, a well-maintained Sugargoo Spreadsheet cuts your
              research time by up to <strong className="text-primary-600">80%</strong> and helps you avoid
              unreliable sellers and low-quality products.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/article/sugargoo-spreadsheet-complete-guide"
                className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2.5 border border-primary-300 text-primary-600 rounded-full text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Browse Spreadsheets
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20desk%20with%20dual%20monitors%20displaying%20colorful%20spreadsheet%20data%20and%20product%20catalogs%2C%20surrounded%20by%20neatly%20arranged%20fashion%20accessories%20and%20sneakers%2C%20warm%20natural%20window%20light%20creating%20soft%20shadows%2C%20organized%20productive%20atmosphere%2C%20scandinavian%20minimalist%20desk%20setup%20with%20plants%20and%20notebooks%2C%20editorial%20photography%20style%2C%20cream%20and%20beige%20tones&width=800&height=600&seq=what-is-sugargoo-v2&orientation=landscape"
                alt="Sugargoo Spreadsheet workspace preview"
                className="w-full h-auto object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-300">
                <th className="py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Method</th>
                <th className="py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Speed</th>
                <th className="py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Product Discovery</th>
                <th className="py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700">Beginner Friendly</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-sm text-foreground-600">Google Search</td>
                <td className="py-3 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-line text-xs"></i>
                    <i className="ri-star-line text-xs"></i>
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-foreground-600">Unreliable, mixed results</td>
                <td className="py-3 px-4 text-sm text-foreground-600">Requires experience</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-sm text-foreground-600">Random Links</td>
                <td className="py-3 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-line text-xs"></i>
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-foreground-600">Hit or miss quality</td>
                <td className="py-3 px-4 text-sm text-foreground-600">Moderate risk</td>
              </tr>
              <tr>
                <td className="py-3 px-4 text-sm font-semibold text-primary-600">Sugargoo Spreadsheet</td>
                <td className="py-3 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-primary-600 font-medium">Verified, curated finds</td>
                <td className="py-3 px-4 text-sm text-primary-600 font-medium">Plug and play</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}